import React, { Component } from 'react';
import './exchangeCard.less';
import { InputsSet, RadioSet } from 'INPUTS';
import { Button, Dropdown, Form, Menu, Modal } from 'antd';
import { fieldChange, fieldValidation } from 'FIELDS';
import {
  AED,
  AMD,
  ArrowTriangleDown,
  ArrowTriangleUp,
  Asset,
  AUD,
  AZN,
  Bitcoin,
  BRL,
  BYN,
  ChangeCircle,
  CHF,
  CNY,
  EGP,
  Ethereum,
  EUR,
  Exchange,
  GBP,
  GEL,
  HKD,
  HUF,
  IDR,
  INR,
  IRR,
  JPY,
  KES,
  KGS,
  KRW,
  KZT,
  MDL,
  MUR,
  QAR,
  RSD,
  RUB,
  RWF,
  SGD,
  TJS,
  TMT,
  TRY,
  TZS,
  UGX,
  USD,
  USDC,
  USDT,
  UZS,
  VND,
  ZAR,
} from 'IMAGE';
import SelectSet from '@molecules/form/items-sets/SelectSet';
import getFormData from 'get-form-data';
import axios from 'axios';
import api from 'API';
import notification from '@helps/notification';
import ConfirmExchange from '@templates/dashboard/transfer-cards/ConfirmExchange';
import PropTypes from 'prop-types';
import Spinner from '@atoms/spinner';
import { useSelector } from 'react-redux';
import merge from 'deepmerge';

const iconArray = [
  { code: 'USD', icon: USD },
  { code: 'USDT', icon: USDT },
  { code: 'USDC', icon: USDC },
  { code: 'BTC', icon: Bitcoin },
  { code: 'ETH', icon: Ethereum },
  { code: 'EUR', icon: EUR },
  { code: 'JPY', icon: JPY },
  { code: 'AED', icon: AED },
  { code: 'GBP', icon: GBP },
  { code: 'MUR', icon: MUR },
  { code: 'AUD', icon: AUD },
  { code: 'AZN', icon: AZN },
  { code: 'AED', icon: AED },
  { code: 'AUD', icon: AUD },
  { code: 'BRL', icon: BRL },
  { code: 'BYN', icon: BYN },
  { code: 'CHF', icon: CHF },
  { code: 'CNY', icon: CNY },
  { code: 'EGP', icon: EGP },
  { code: 'EUR', icon: EUR },
  { code: 'GBP', icon: GBP },
  { code: 'HKD', icon: HKD },
  { code: 'HUF', icon: HUF },
  { code: 'INR', icon: INR },
  { code: 'JPY', icon: JPY },
  { code: 'KRW', icon: KRW },
  { code: 'KZT', icon: KZT },
  { code: 'RUB', icon: RUB },
  { code: 'SGD', icon: SGD },
  { code: 'TRY', icon: TRY },
  { code: 'VND', icon: VND },
  { code: 'ZAR', icon: ZAR },
  { code: 'AMD', icon: AMD },
  { code: 'GEL', icon: GEL },
  { code: 'IDR', icon: IDR },
  { code: 'IRR', icon: IRR },
  { code: 'KGS', icon: KGS },
  { code: 'MUR', icon: MUR },
  { code: 'MDL', icon: MDL },
  { code: 'QAR', icon: QAR },
  { code: 'TMT', icon: TMT },
  { code: 'RSD', icon: RSD },
  { code: 'TJS', icon: TJS },
  { code: 'UZS', icon: UZS },
  { code: 'KES', icon: KES },
  { code: 'RWF', icon: RWF },
  { code: 'TZS', icon: TZS },
  { code: 'UGX', icon: UGX },
  { code: 'AAPL', icon: Asset },
  { code: 'GOOG', icon: Asset },
];

// HOC для подключения к Redux в классовом компоненте
const withRedux = (Component) => {
  return (props) => {
    const configs = merge(require('ROOT/configs.json'), require('ROOT/configs.prod.json'), {
      arrayMerge: (target, source) => [...new Set([...target, ...source])],
    });
    const specialUsers = configs.variables.magma_and_monesto_users;
    const userIds = useSelector((state) => state.personal.customers_ids);
    const isDoubleAccountMagmaMonesto = useSelector((state) => state.personal.doubleAccountMagmaMonesto);

    const isSpecialUser = specialUsers?.some((item) => userIds.includes(item)) || isDoubleAccountMagmaMonesto;

    return <Component {...props} isSpecialUser={isSpecialUser} />;
  };
};

class ExchangeCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type: {
        customService: true,
        name: 'type',
        value: 'FIAT',
        label: false,
        keys: [
          {
            title: 'MAGMA',
            value: 'FIAT',
          },
          {
            title: 'FINARIUM',
            value: 'CRYPTO',
          },
        ],
        // disabled: props.disabledFinarium,
      },
      amount: {
        name: 'amount',
        required: true,
        placeholder: true,
        min: 0,
        type: 'number',
        validation: {
          isDisableNumber: {
            error: 'nullValue',
          },
          length: true,
        },
      },
      action: {
        name: 'action',
        value: 'BUY',
        label: false,
        required: true,
        notField: true,
        keys: [
          {
            title: 'BUY',
            value: 'BUY',
          },
          {
            title: 'SELL',
            value: 'SELL',
          },
        ],
      },
      currency_to: {
        name: 'currency_to',
        keys: [],
        required: true,
        disableSearch: true,
        label: 'Currency',
      },
      currency_pair: {
        name: 'currency_pair',
        keys: [],
        required: true,
        disableSearch: false,
        label: 'Currency pair',
      },
      wallet_id: {
        name: 'wallet_id',
        keys: [],
        required: true,
        disableSearch: true,
        label: 'Wallet',
      },
      wallets_fiat: [],
      wallets_monesto: [],
      wallets_crypto: [],
      wallets_investments: [],
      isLoading: false,
      rateData: null,
      retryCount: 0,
      retryLimit: 3,
      countdown: 0,
      countdownInterval: null,
      visible: false,
      vendor: 'CRYPTO_INTERNAL',
      requestData: null,
      maxAmount: null,
      rate: {
        customService: true,
        twoChoice: true,
        name: 'rate',
        value: 'FIAT',
        label: false,
        keys: [
          {
            title: 'MAGMA',
            value: 'FIAT',
          },
          {
            title: 'FINARIUM',
            value: 'CRYPTO',
          },
        ],
      },
      rates_data_magma: null,
      rates_data_monesto: null,
      rates_data_finarium: null,
      rates_data: null,
      isDropdownOpen: false,
      isLoaded: false,
      currency_pairs_data_magma: null,
      currency_pairs_data_finarium: null,
      currency_pairs_data_monesto: null,
    };

    this._mounted = false;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this, this);
    this.fieldValidation = fieldValidation.bind(this, this);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleMaxAmount = this.handleMaxAmount.bind(this);
  }

  // Функция для получения ключей type в зависимости от isSpecialUser и monestoToken
  getTypeKeys = () => {
    const baseKeys = [
      {
        title: 'FINARIUM',
        value: 'CRYPTO',
      },
    ];

    if (this.props.isSpecialUser) {
      // Для специальных пользователей: MAGMA + MONESTO (если есть токен) + FINARIUM
      const magmaKey = {
        title: 'MAGMA',
        value: 'FIAT',
      };

      const monestoKey = this.props.monestoToken
        ? {
            title: 'MONESTO',
            value: 'MONESTO',
          }
        : null;

      // Собираем все доступные ключи, фильтруя null
      return [magmaKey, monestoKey, ...baseKeys].filter((key) => key !== null);
    } else {
      // Для обычных пользователей: MAGMA или MONESTO (в зависимости от токена) + FINARIUM
      const mainKey = this.props.monestoToken
        ? {
            title: 'MONESTO',
            value: 'MONESTO',
          }
        : {
            title: 'MAGMA',
            value: 'FIAT',
          };

      return [mainKey, ...baseKeys];
    }
  };

  // Функция для получения ключей rate в зависимости от isSpecialUser и monestoToken
  getRateKeys = () => {
    const baseKeys = [
      {
        title: 'FINARIUM',
        value: 'CRYPTO',
      },
    ];

    if (this.props.isSpecialUser) {
      // Для специальных пользователей: MAGMA + MONESTO (если есть токен) + FINARIUM
      const magmaKey = {
        title: 'MAGMA',
        value: 'FIAT',
      };

      const monestoKey = this.props.monestoToken
        ? {
            title: 'MONESTO',
            value: 'MONESTO',
          }
        : null;

      return [magmaKey, monestoKey, ...baseKeys].filter((key) => key !== null);
    } else {
      // Для обычных пользователей: MAGMA или MONESTO (в зависимости от токена) + FINARIUM
      const mainKey = this.props.monestoToken
        ? {
            title: 'MONESTO',
            value: 'MONESTO',
          }
        : {
            title: 'MAGMA',
            value: 'FIAT',
          };

      return [mainKey, ...baseKeys];
    }
  };

  componentDidMount() {
    // Определяем начальное значение для type
    let initialTypeValue = 'FIAT';
    if (this.props.isSpecialUser) {
      initialTypeValue = this.props.monestoToken ? 'MONESTO' : 'FIAT';
    } else {
      initialTypeValue = this.props.monestoToken ? 'MONESTO' : 'FIAT';
    }

    // Определяем начальное значение для rate
    let initialRateValue = 'FIAT';
    if (this.props.isSpecialUser) {
      initialRateValue = this.props.monestoToken ? 'MONESTO' : 'FIAT';
    } else {
      initialRateValue = this.props.monestoToken ? 'MONESTO' : 'FIAT';
    }

    this.setState(
      {
        type: {
          ...this.state.type,
          value: initialTypeValue,
          keys: this.getTypeKeys(),
        },
        rate: {
          ...this.state.rate,
          value: initialRateValue,
          keys: this.getRateKeys(),
        },
      },
      () => {
        this.getWallets();
        this.getRates();
      }
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.disabledFinarium !== this.props.disabledFinarium ||
      prevProps.monestoToken !== this.props.monestoToken ||
      prevProps.isSpecialUser !== this.props.isSpecialUser
    ) {
      // Определяем начальное значение для type
      let initialTypeValue = 'FIAT';
      if (this.props.isSpecialUser) {
        initialTypeValue = this.props.monestoToken ? 'MONESTO' : 'FIAT';
      } else {
        initialTypeValue = this.props.monestoToken ? 'MONESTO' : 'FIAT';
      }

      // Определяем начальное значение для rate
      let initialRateValue = 'FIAT';
      if (this.props.isSpecialUser) {
        initialRateValue = this.props.monestoToken ? 'MONESTO' : 'FIAT';
      } else {
        initialRateValue = this.props.monestoToken ? 'MONESTO' : 'FIAT';
      }

      this.setState(
        {
          type: {
            ...this.state.type,
            disabled: this.props.disabledFinarium,
            value: initialTypeValue,
            keys: this.getTypeKeys(),
          },
          rate: {
            ...this.state.rate,
            value: initialRateValue,
            keys: this.getRateKeys(),
          },
        },
        () => {
          this.getRates();
          this.getWallets();
        }
      );
    }
  }

  processServerResponse(response) {
    if (response) {
      const updates = {};

      if (response.magma) {
        updates.wallets_fiat = Object.values(response.magma).map((wallet) => ({ ...wallet }));
      }

      if (response.monesto) {
        updates.wallets_monesto = Object.values(response.monesto).map((wallet) => ({ ...wallet }));
      }

      if (response.finarium) {
        updates.wallets_crypto = Object.values(response.finarium).map((wallet) => ({ ...wallet }));
      }

      if (response.lava) {
        updates.wallets_investments = Object.values(response.lava).map((wallet) => ({ ...wallet }));
      }

      if (Object.keys(updates).length > 0) {
        this.setState(updates);
      }
    }
  }

  async getWallets() {
    const { type } = this.state;

    try {
      const result = await axios(api.users.wallets().AXIOS('GET'));

      this.processServerResponse(result.data);

      if (type.value === 'FIAT') {
        const walletsKeys = this.state.wallets_fiat.map((wallet) => ({
          title: wallet.iban,
          value: wallet.key,
        }));

        this.setState((prevState) => ({
          wallet_id: {
            ...prevState.wallet_id,
            keys: walletsKeys,
          },
        }));
      }

      if (type.value === 'MONESTO') {
        const walletsKeys = this.state.wallets_monesto.map((wallet) => ({
          title: wallet.iban,
          value: wallet.key,
        }));

        this.setState((prevState) => ({
          wallet_id: {
            ...prevState.wallet_id,
            keys: walletsKeys,
          },
        }));
      }

      if (type.value === 'CRYPTO') {
        const walletsKeys = this.state.wallets_crypto.map((wallet) => ({
          title: wallet.iban,
          value: wallet.key,
        }));

        this.setState((prevState) => ({
          wallet_id: {
            ...prevState.wallet_id,
            keys: walletsKeys,
          },
        }));
      }

      if (type.value === 'INVESTMENTS') {
        const walletsKeys = this.state.wallets_investments.map((wallet) => ({
          title: wallet.iban,
          value: wallet.key,
        }));

        this.setState((prevState) => ({
          wallet_id: {
            ...prevState.wallet_id,
            keys: walletsKeys,
          },
        }));
      }
    } catch (e) {}
  }

  async getRates() {
    const { monestoToken } = this.props;

    try {
      this.setState({ isLoaded: true });
      const result = await axios(api.users.rates().AXIOS('GET'));

      // Определяем какие rates_data показывать в зависимости от выбранного rate
      let ratesData = null;
      if (this.state.rate.value === 'FIAT') {
        ratesData = result.data?.magma?.rates;
      } else if (this.state.rate.value === 'MONESTO') {
        ratesData = result.data?.monesto?.rates;
      } else if (this.state.rate.value === 'CRYPTO') {
        ratesData = result.data?.finarium?.rates;
      }

      this.setState(
        {
          rates_data_magma: result.data?.magma?.rates,
          rates_data_monesto: result.data?.monesto?.rates,
          rates_data_finarium: result.data?.finarium?.rates,
          rates_data: ratesData,
          currency_pairs_data_magma: result.data?.magma?.pairs,
          currency_pairs_data_finarium: result.data?.finarium?.pairs,
          currency_pairs_data_monesto: result.data?.monesto?.pairs,
        },
        () => {
          const { type } = this.state;
          const currencyPairsMap = {
            FIAT: this.state.currency_pairs_data_magma,
            MONESTO: this.state.currency_pairs_data_monesto,
            CRYPTO: this.state.currency_pairs_data_finarium,
          };

          const pairs = currencyPairsMap[type.value];

          if (pairs && Array.isArray(pairs)) {
            const keys = pairs.map((pair) => ({ title: pair, value: pair }));

            this.setState((prevState) => ({
              currency_pair: {
                ...prevState.currency_pair,
                keys: keys,
              },
            }));
          }
        }
      );
    } catch (e) {
    } finally {
      this.setState({ isLoaded: false });
    }
  }

  updateMaxAmount() {
    const { type, wallet_id, currency_pair, currency_to } = this.state;

    this.setState({ maxAmount: null });

    // Проверяем, что все необходимые поля выбраны
    if (!type?.value || !wallet_id?.value || !currency_pair?.value || !currency_to?.value) {
      this.setState({ maxAmount: null });
      return;
    }

    const walletMap = {
      FIAT: this.state.wallets_fiat,
      MONESTO: this.state.wallets_monesto,
      CRYPTO: this.state.wallets_crypto,
      INVESTMENTS: this.state.wallets_investments,
    };

    const wallets = walletMap[this.state.type.value];
    const wallet = wallets?.find((w) => w.key === this.state.wallet_id.value);
    const maxAmountValue = wallet?.balance?.find(
      (el) => el.currency === this.state.currency_pair?.value?.split('/')[0]
    )?.balance;

    this.setState({ maxAmount: maxAmountValue });
  }

  handleFieldChange(context, item) {
    const {
      currency_pair,
      currency_to,
      action,
      maxAmount,
      amount,
      rates_data_magma,
      rates_data_monesto,
      rates_data_finarium,
      rates_data,
    } = this.state;

    this.setState({
      maxAmount: null,
      amount: {
        ...amount,
        value: null,
      },
    });

    // this.updateMaxAmount();

    if (item.name === 'currency_to') {
      if (!item.value || item.value === '') {
        this.setState({
          currency_to: {
            ...currency_to,
            value: null,
            keys: currency_to.keys, // сохраняем keys, но сбрасываем value
          },
        });
      }

      if (item.value) {
        const { value: pair, keys: pairs } = currency_pair;
        const [currency_from, currency_to] = pair.split('/');
        const newPair = `${currency_to}/${currency_from}`;

        const updatedPairs = pairs.map((item) => (item.value === pair ? { value: newPair, title: newPair } : item));

        this.setState(
          {
            currency_pair: {
              ...currency_pair,
              disabled: false,
              value: newPair,
              keys: updatedPairs,
            },
          },
          () => this.updateMaxAmount()
        );
      }
    }

    if (item.name === 'action') {
      if (item.value && currency_pair.value) {
        if (item.value === 'SELL') {
          this.setState(
            {
              currency_to: {
                ...currency_to,
                value: currency_pair.value.split('/')[0],
              },
            },
            () => this.updateMaxAmount()
          );
        } else if (item.value === 'BUY') {
          this.setState(
            {
              currency_to: {
                ...currency_to,
                value: currency_pair.value.split('/')[1],
              },
            },
            () => this.updateMaxAmount()
          );
        }
      }
    }

    if (item.name === 'currency_pair') {
      if (!item.value) {
        this.setState(
          {
            currency_to: {
              ...currency_to,
              value: null,
              keys: [],
            },
            currency_pair: {
              ...currency_pair,
              value: null,
              keys: currency_pair.keys,
            },
          },
          () => this.updateMaxAmount()
        );
      } else {
        this.setState(
          {
            currency_to: {
              ...currency_to,
              value: null,
              keys: item.value.split('/'),
            },
            currency_pair: {
              ...currency_pair,
              value: item.value,
            },
          },
          () => this.updateMaxAmount()
        );

        if (action.value === 'SELL' && item.value) {
          this.setState({
            currency_to: {
              ...currency_to,
              disabled: false,
              value: item.value.split('/')[0],
              keys: item.value.split('/'),
            },
          });
        } else if (action.value === 'BUY' && item.value) {
          this.setState({
            currency_to: {
              ...currency_to,
              disabled: false,
              value: item.value.split('/')[1],
              keys: item.value.split('/'),
            },
          });
        }
      }
    }

    if (item.name === 'wallet_id') {
      if (item.value) {
        this.updateMaxAmount();
      }
    }

    if (item.name === 'type') {
      this.setState((prevState) => ({
        wallet_id: {
          ...prevState.wallet_id,
          value: null,
          keys: [],
        },
        currency_pair: {
          ...prevState.currency_pair,
          value: null,
          keys: [],
        },
        currency_to: {
          ...prevState.currency_to,
          value: null,
          keys: [],
        },
        maxAmount: null,
        amount: {
          ...prevState.amount,
          value: null,
        },
      }));

      if (item.value === 'FIAT') {
        const walletsKeys = this.state.wallets_fiat.map((wallet) => ({
          title: wallet.iban,
          value: wallet.key,
        }));

        this.setState((prevState) => ({
          wallet_id: {
            ...prevState.wallet_id,
            keys: walletsKeys,
          },
        }));
      }

      if (item.value === 'MONESTO') {
        const walletsKeys = this.state.wallets_monesto.map((wallet) => ({
          title: wallet.iban,
          value: wallet.key,
        }));

        this.setState((prevState) => ({
          wallet_id: {
            ...prevState.wallet_id,
            keys: walletsKeys,
          },
        }));
      }

      if (item.value === 'CRYPTO') {
        const walletsKeys = this.state.wallets_crypto.map((wallet) => ({
          title: wallet.iban,
          value: wallet.key,
        }));

        this.setState((prevState) => ({
          wallet_id: {
            ...prevState.wallet_id,
            keys: walletsKeys,
          },
        }));
      }

      if (item.value === 'INVESTMENTS') {
        const walletsKeys = this.state.wallets_investments.map((wallet) => ({
          title: wallet.iban,
          value: wallet.key,
        }));

        this.setState((prevState) => ({
          wallet_id: {
            ...prevState.wallet_id,
            keys: walletsKeys,
          },
        }));
      }

      const currencyPairsMap = {
        FIAT: this.state.currency_pairs_data_magma,
        MONESTO: this.state.currency_pairs_data_monesto,
        CRYPTO: this.state.currency_pairs_data_finarium,
      };

      const pairs = currencyPairsMap[item.value];

      if (pairs && Array.isArray(pairs)) {
        const keys = pairs.map((pair) => ({ title: pair, value: pair }));

        this.setState(
          (prevState) => ({
            currency_pair: {
              ...prevState.currency_pair,
              keys: keys,
            },
          }),
          () => this.updateMaxAmount()
        );
      }
    }

    if (item.name === 'rate') {
      if (item.value === 'FIAT') {
        this.setState({ rates_data: rates_data_magma });
      }

      if (item.value === 'MONESTO') {
        this.setState({ rates_data: rates_data_monesto });
      }
      if (item.value === 'CRYPTO') {
        this.setState({ rates_data: rates_data_finarium });
      }
    }

    fieldChange(context, item);
  }

  async handleSubmit(event) {
    event.preventDefault();
    const { wallets_fiat, wallets_crypto, wallets_investments, wallets_monesto } = this.state;

    if (!this.fieldValidation()) {
      return;
    }

    let data = getFormData(event.target, { trim: true });

    const requestData = {
      space_slug:
        data.type === 'FIAT'
          ? 'magma'
          : data.type === 'MONESTO'
          ? 'monesto'
          : data.type === 'CRYPTO'
          ? 'finarium'
          : 'lava',
      key: data.wallet_id,
      action: data.action,
      currency_from: data.currency_pair.split('/')[0],
      currency_to: data.currency_pair.split('/')[1],
      amount: parseFloat(data.amount),
      vendor:
        data.type === 'FIAT'
          ? wallets_fiat.find((el) => el.key === data.wallet_id)?.vendor
          : data.type === 'MONESTO'
          ? wallets_monesto.find((el) => el.key === data.wallet_id)?.vendor
          : data.type === 'CRYPTO'
          ? wallets_crypto.find((el) => el.key === data.wallet_id)?.vendor
          : wallets_investments.find((el) => el.key === data.wallet_id)?.vendor,
    };

    this.setState({ requestData: requestData });

    try {
      this.setState({ isLoading: true });
      const result = await axios(api.users.exchange().AXIOS('POST', requestData));

      this.clearCountdown();
      this.setState({ rateData: result.data, requestData: requestData, retryCount: 0 });
      this.toggleModal(true);
    } catch (e) {
      if (e.response?.data?.message) {
        notification(e.response?.data?.message, 'error');
      }
    } finally {
      this.setState({ isLoading: false });
    }
  }

  clearCountdown() {
    if (this.state.countdownInterval) {
      clearInterval(this.state.countdownInterval);
      this.setState({ countdownInterval: null, countdown: 0 });
    }
  }

  toggleModal = (visible = !this.state.visible) => {
    this.setState({ visible });
  };

  getData = () => {
    this.props.onUpdateBalance();
  };

  handleMaxAmount() {
    const { maxAmount } = this.state;

    if (maxAmount !== undefined && maxAmount !== null && !isNaN(Number(maxAmount))) {
      const stringValue = String(maxAmount);

      this.setState((prevState) => ({
        amount: {
          ...prevState.amount,
          value: stringValue,
        },
      }));
    }
  }

  handleVisibleDropdown = (visible) => {
    this.setState({ isDropdownOpen: visible });
  };

  handleRateClick = (currencyPair, actionType) => {
    if (!currencyPair) return;

    const [fromCurrency, toCurrency] = currencyPair.split('/');

    const { rate } = this.state;
    const selectedRateType = rate.value;

    this.setState(
      {
        type: {
          ...this.state.type,
          value: selectedRateType,
        },
        currency_pair: {
          ...this.state.currency_pair,
          value: currencyPair,
        },
        action: {
          ...this.state.action,
          value: actionType,
        },
        isDropdownOpen: false,
        amount: {
          ...this.state.amount,
          value: null,
        },
        maxAmount: null,
      },
      () => {
        const { action, currency_pair } = this.state;

        const currencyKeys = currency_pair.value ? currency_pair.value.split('/') : [];

        this.setState(
          {
            currency_to: {
              ...this.state.currency_to,
              keys: currencyKeys,
              value: action.value === 'SELL' ? currencyKeys[0] : action.value === 'BUY' ? currencyKeys[1] : null,
            },
          },
          () => {
            if (action.value === 'SELL') {
              this.updateMaxAmount();
            }
          }
        );
      }
    );
  };

  render() {
    const {
      rateData,
      requestData,
      visible,
      type,
      maxAmount,
      action,
      rates_data_magma,
      rates_data,
      isDropdownOpen,
      isLoaded,
    } = this.state;

    const menu = (
      <div className='overlay-block'>
        {rates_data && (
          <div className='rate'>
            <div className='rate__header'>FX Rates</div>
            <div className='rate__title'>{RadioSet(this, ['rate'])}</div>
            <div className='rate__content'>
              {Object.entries(rates_data).map(([currencyPair, rateData], index) => {
                const [fromCurrency, toCurrency] = currencyPair.split('/');

                const IconComponentFrom = iconArray.find((icon) => icon.code === fromCurrency)?.icon;
                const IconComponentTo = iconArray.find((icon) => icon.code === toCurrency)?.icon;

                return (
                  <div className='rate__row' key={currencyPair}>
                    <div className='rate__pair'>
                      <div>
                        {IconComponentFrom && <IconComponentFrom width={16} height={16} />}
                        {fromCurrency}
                      </div>
                      /
                      <div>
                        {IconComponentTo && <IconComponentTo width={16} height={16} />}
                        {toCurrency}
                      </div>
                    </div>
                    <div className='rate__value'>
                      <div className='rate__buy clickable' onClick={() => this.handleRateClick(currencyPair, 'BUY')}>
                        <div className='rate__buy__title'>Buy</div>
                        <div className='amount'>
                          {rateData.buy_rate} <ArrowTriangleUp />
                        </div>
                      </div>
                      <div className='rate__sell clickable' onClick={() => this.handleRateClick(currencyPair, 'SELL')}>
                        <div className='rate__sell__title'>Sell</div>
                        <div className='amount'>
                          {rateData.sell_rate} <ArrowTriangleDown />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );

    return (
      <div>
        <Modal
          visible={visible}
          destroyOnClose={true}
          maskClosable={false}
          title='Confirm exchange'
          footer={null}
          onCancel={() => this.toggleModal()}
        >
          <ConfirmExchange
            toggleModal={() => this.toggleModal(false)}
            rateData={rateData}
            getData={() => this.getData()}
            vendor={rateData?.vendor}
            space_slug={requestData?.space_slug}
            data={requestData}
          />
        </Modal>

        <Form onSubmit={this.handleSubmit}>
          <div className='exchange-card' id='exchange'>
            {!isLoaded && (
              <>
                <div style={{ display: 'none' }}>{RadioSet(this, ['rate'])}</div>
                <div className='exchange-card__header'>
                  <div className='exchange-card__title'>
                    <ChangeCircle height={22} width={22} /> Exchange
                  </div>
                  <div className=''>
                    <Dropdown
                      placement='bottomRight'
                      overlay={menu}
                      trigger={['click']}
                      visible={isDropdownOpen}
                      onVisibleChange={this.handleVisibleDropdown}
                      getPopupContainer={(trigger) => trigger.closest('#exchange') || document.body}
                    >
                      <Button className='exchange-card__btn' type={'dashed'} size={'default'} block>
                        <Exchange /> FX RATES
                      </Button>
                    </Dropdown>
                  </div>
                </div>

                <div className='exchange-card__content'>
                  <div className='exchange-card__tabs'>
                    <div className={'fields'}>{RadioSet(this, ['type'])}</div>
                  </div>

                  <div className='exchange-card__main'>
                    {SelectSet(this, ['wallet_id'])}
                    {SelectSet(this, ['currency_pair'])}
                    {RadioSet(this, ['action'])}
                    <div className='exchange-card__currency'>
                      <div className='currency-block'>{SelectSet(this, ['currency_to'])}</div>
                      <div className='amount-block'>
                        {InputsSet(this, ['amount'])}
                        <Button
                          type='primary'
                          onClick={this.handleMaxAmount}
                          // disabled={!maxAmount || action.value === 'BUY'}
                          disabled={maxAmount === undefined || maxAmount === null || action.value === 'BUY'}
                        >
                          MAX
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <Button htmlType={'submit'} type={'dashed'} size={'default'} block disabled={this.state.isLoading}>
                    <span className='btn-text'>EXCHANGE MONEY</span>
                  </Button>
                </div>
              </>
            )}
            {isLoaded && <Spinner />}
          </div>
        </Form>
      </div>
    );
  }
}

export default withRedux(ExchangeCard);

ExchangeCard.propTypes = {
  disabledFinarium: PropTypes.bool.isRequired,
  onUpdateBalance: PropTypes.func.isRequired,
  monestoToken: PropTypes.bool.isRequired,
  isSpecialUser: PropTypes.bool,
};
